<template>
	<div class="container-fluid">
		<div class="card">
      <div class="card-header">
        <h2 class="card-title">Blog</h2>
      </div>
      <div class="card-body">
      	<article>
      		<div v-for="entrada in entradas" :key="entrada.id" :class="`entradas_blog shadow px-2 py-3 mb-3 border ${es_leido(entrada)}`">
      			<h3 class="title px-2 py-3">{{ entrada.titulo }}</h3>
      			<div class="descript px-4 py-3" v-html="entrada.resumen"></div>
      			<div class="options">
      				<div class="row px-2">
      					<div class="col-sm-2">
      						<button class="btn btn-secondary" @click="$router.push({name: 'blogs_entrada', params:{id: entrada.id}})">Leer más...</button>
      					</div>
      					<div class="col-sm-2 offset-sm-8 text-right">Publicado: {{ $moment(entrada.publicacion_at).format('DD-MM-YYYY HH:mm')+' hrs' }}</div>
      				</div>
      			</div>
      		</div>
      	</article>
      </div>
    </div>
	</div>
</template>

<script type="text/javascript">
	import api from '@/api/clientes'

	export default {
		data: function() {
			return {
				entradas: []
			}
		}
		,mounted: function() {
			this.obtener_entrdas();
		}
		,methods: {
			obtener_entrdas: async function() {
				try {
					this.entradas = (await api.obtener_blog_entradas()).data
				}catch(e) {
					this.$log.info('Err', e);
                	this.$swal('Error','Error al descargar las facturas: '+e.message,'error');
				}
			}
			,es_leido: function(entrada) {
				return entrada.leidos.length > 0 ? 'entrada_leida' : '';
			}
		}
	}
</script>

<style lang="scss">
	.entradas_blog {
		.title {
			background-color: #f8f9fa;
			color: #00B367;
			font-size: 1.3em;
			font-weight: bold;
		}
		.descript {
			.understrap-read-more-link {
				display: none !important;
			}
		}
		.options {
			font-size: 0.8em;
		}
	}
	.entrada_leida {
		background-color: #f8f9fa;

		.title {
			color: #C4C4C4!important;
		}

		.btn-secondary {
			background-color: #ABADAE;
			border-color: #9E9E9E;
		}
	}
</style>